<div class="row" (window:resize)="resize()" #upload_div>
  @for (file of attachedFiles; track file.id) {
    <div class="col-md-3 col-sm-4 col-xs-6">
      <div class="attach attach-image">
        @if (!!file.thumbnail) {
          <div class="attach-file">
            <img [src]="file.thumbnail" />
          </div>
        } @else {
          <div class="file-format"><i [ngClass]="file.file_name | fileIconClass"></i></div>
        }
        <a class="file-name">{{ file.file_name }}</a>
      </div>
    </div>
  }

  @for (item of uploader.queue; track item) {
    <div class="col-md-3 col-sm-4 col-xs-6">
      <div class="attach attach-image">
        @if (isShowPreview(item)) {
          <div class="attach-file">
            <img appImagePreview [image]="item?._file" />
          </div>
        } @else {
          <div class="file-format"><i [ngClass]="item?.file?.name | fileIconClass"></i></div>
        }
        <a class="file-name">
          {{ item?.file?.name }}
          @if (item.isError) {
            <span>
              <i class="fa fa-exclamation-triangle" aria-hidden="true">&nbsp;Failed to upload</i>
            </span>
          }
        </a>
      </div>
    </div>
  }
</div>

@if (canEdit) {
  <div>
    @if (!isExistFileUploaded) {
      <div>
        <p class="empty-file">未選択</p>
        <label class="tea-add-file" for="file-upload">
          <span class="spen-util-link" [style.margin-bottom]="attachFilesErrMsg ? '0' : ''">
            {{ isExistFileUploaded ? '画像を変更する' : '画像を選択する' }}
          </span>
        </label>
        <input
          id="file-upload"
          class="input-file"
          type="file"
          (change)="onSelectFile($event)"
          [accept]="acceptTypes"
          ng2FileSelect
          [uploader]="uploader"
        />
      </div>
    } @else {
      <label class="tea-add-file" for="file-upload">
        <span class="spen-util-link" data-cy="delete-cover-image" (click)="removeItems()">削除する</span>
      </label>
    }
  </div>
}
<div class="error-popup">
  @if (attachFilesErrMsg) {
    <div class="spen-mod-error-content">
      {{ attachFilesErrMsg }}
    </div>
  }
</div>

@if (showProgressbar) {
  <app-upload-files-progress [progress]="uploader.progress" (cancelFilesEvent)="cancelUploadingFiles()"> </app-upload-files-progress>
}
